export default function setDelay(setLoadingIndicator) {
  setTimeout(() => {
    setLoadingIndicator(false);
  }, 300);
}
